import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "La Marmotte Joyeuse - Hébergement de charme dans les Alpes | La Grave",
  description = "La Marmotte Joyeuse - Hébergement de charme dans les Alpes françaises à La Grave. Appartements confortables, vue panoramique, activités montagne. Réservez votre séjour inoubliable.",
  keywords = "hébergement alpes, appartement la grave, location montagne, marmotte joyeuse, séjour alpes, station ski, randonnée montagne",
  image = "https://marmottejoyeuse.fr/photo-site/lameijeete.jpg",
  url = "https://marmottejoyeuse.fr",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes('La Marmotte Joyeuse') ? title : `${title} | La Marmotte Joyeuse`;
  const fullUrl = url.startsWith('http') ? url : `https://marmottejoyeuse.fr${url}`;
  const fullImage = image.startsWith('http') ? image : `https://marmottejoyeuse.fr${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="La Marmotte Joyeuse" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="author" content="La Marmotte Joyeuse" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
